import { render, staticRenderFns } from "./AccessoCafSelettore.vue?vue&type=template&id=c1141f68&"
import script from "./AccessoCafSelettore.vue?vue&type=script&lang=js&"
export * from "./AccessoCafSelettore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccessoCafSelettore.vue"
export default component.exports